import React from 'react';
import PropTypes from 'prop-types';
import TeamSettingsForm from './components/TeamSettingsForm';
import CMSSettingsForm from './components/CMSSettingsForm';
import UserSettingsForm from './components/UserSettingsForm';
import ErrorMessage from '../../shared/message/ErrorMessage';
import Modal from 'react-modal';
import TextInput from '../../shared/inputs/TextInput';
import Button from '../../shared/buttons/Button';
import TeamModal from '../../shared/team/TeamModal';
import { Helmet } from 'react-helmet';

class SettingsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadTeamSettings = this.loadTeamSettings.bind(this);
    this.updateUserSettings = this.updateUserSettings.bind(this);
    this.updateTeamSettings = this.updateTeamSettings.bind(this);
    this.updateSettings = this.updateSettings.bind(this);
    this.saveUserSettings = this.saveUserSettings.bind(this);
    this.saveTeamSettings = this.saveTeamSettings.bind(this);
    this.generateLicense = this.generateLicense.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this.deleteTeam = this.deleteTeam.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.updateState = this.updateState.bind(this);
    this.openNewTeamModal = this.openNewTeamModal.bind(this);
    this.closeNewTeamModal = this.closeNewTeamModal.bind(this);
  }

  componentDidMount() {
    if (this.props.checkPermission('team_management')) this.loadTeamSettings();
    if (this.props.checkPermission('team_management')) this.props.getCMSLicenseAction(this.props.team);

    this.props.set({
      userSettings: {
        username: this.props.user.username,
        email_verified: this.props.user.email_verified,
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    if (isDifferentTeam) {
      if (this.props.checkPermission('team_management')) this.loadTeamSettings();
      if (this.props.checkPermission('team_management')) this.props.getCMSLicenseAction(this.props.team);
    }
  }

  loadTeamSettings() {
    this.props.getTeamProfile(this.props.team);
  }

  updateUserSettings(event) {
    this.updateSettings(event, 'userSettings');
  }

  updateTeamSettings(event) {
    this.updateSettings(event, 'teamSettings');
  }

  updateSettings(event, form) {
    const field = event.target.name;
    let settings = this.props[form];
    settings[field] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    return this.props.set({ settings });
  }

  saveUserSettings(event) {
    event.preventDefault();
    this.props.saveUserSettings(this.props.userSettings);
  }

  saveTeamSettings(event) {
    event.preventDefault();
    this.props.saveTeamSettings(this.props.team, this.props.teamSettings);
  }

  generateLicense(event) {
    event.preventDefault();
    this.props.generateLicense(this.props.team);
  }

  deleteTeam() {
    this.props.deleteTeam(this.props.team, this.props.form);
  }

  verifyEmail(event) {
    event.preventDefault();
    this.props.verifyEmail();
  }

  toggleDeleteModal(event) {
    event.preventDefault();
    this.props.set({ showDeleteModal: !this.props.showDeleteModal });
  }

  updateState(event) {
    const field = event.target.name;
    let form = this.props.form;
    form[field].value = event.target.value;
    form[field].error = false;
    return this.props.set({ form });
  }

  openNewTeamModal() {
    this.props.set({ showNewTeamModal: true });
  }

  closeNewTeamModal() {
    this.props.set({ showNewTeamModal: false });
  }

  render() {
    const parentSelector = () => document.querySelector('.page-container');

    return (
      <div>
        <Helmet>
          <title> Settings </title>
        </Helmet>
        <TeamModal
          isOpen={this.props.showNewTeamModal}
          parentSelector={parentSelector}
          close={this.closeNewTeamModal}
          reloadTeams={this.props.reloadTeams}
        />

        <Modal
          className="hc-modal-content"
          overlayClassName="hc-modal-overlay"
          parentSelector={parentSelector}
          isOpen={this.props.showDeleteModal}
          appElement={document.querySelector('.page-container')}
          onRequestClose={this.toggleDeleteModal}
          contentLabel=""
        >
          <ErrorMessage error={this.props.showDeleteError} />
          <p>Please type in the name of the team to delete.</p>
          <TextInput
            name="teamName"
            onChange={this.updateState}
            placeholder="Enter Team Name"
            value={this.props.form.teamName.value}
            autoFocus={true}
          />
          <Button buttonText="Confirm" extraClass="bulk-action-btn danger" onClick={this.deleteTeam} />{' '}
          <Button buttonText="Cancel" extraClass="bulk-action-btn grey" onClick={this.toggleDeleteModal} />
        </Modal>

        <div className="main-content-container">
          <ErrorMessage error={this.props.error} />
          {this.props.userSettings && (
            <div className="col-xs-12 col-md-9 col-lg-8">
              <h2 className="setting-header"> User settings </h2>
              <UserSettingsForm
                settings={this.props.userSettings}
                onChange={this.updateUserSettings}
                onSave={this.saveUserSettings}
                saving={this.props.saving}
                sending={this.props.sending}
                onClick={this.verifyEmail}
              />
            </div>
          )}

          {this.props.checkPermission('team_management') && (
            <div className="col-xs-12 col-md-9 col-lg-8">
              <h2 className="setting-header"> Team settings </h2>
              <TeamSettingsForm
                settings={this.props.teamSettings}
                onChange={this.updateTeamSettings}
                onSave={this.saveTeamSettings}
                onDelete={this.toggleDeleteModal}
                deleting={this.props.deleting}
                saving={this.props.saving}
                checkPermission={this.props.checkPermission}
                team={this.props.team}
                openNewTeamModal={this.openNewTeamModal}
              />
            </div>
          )}

          {this.props.checkPermission('team_management') && (
            <div className="col-xs-12 col-md-9 col-lg-8">
              <h2 className="setting-header"> CMS settings </h2>
              <CMSSettingsForm
                settings={this.props.teamSettings}
                generateLicense={this.generateLicense}
                generatingLicense={this.props.generatingLicense}
                checkPermission={this.props.checkPermission}
                team={this.props.team}
                cmsLicenseKey={this.props.cmsLicenseKey}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

SettingsPage.propTypes = {
  user: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
  checkPermission: PropTypes.func,
  removeTeam: PropTypes.func,
  updateTeams: PropTypes.func,
  showModal: PropTypes.func,
  reloadTeams: PropTypes.func,
};

export default SettingsPage;
